import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from "./components/Header";
import Footer from './components/Footer';
import { ThemeProvider } from './hooks/useTheme';
import { PaletteProvider } from './hooks/usePalette';

export default function App() {
  return (
    <ThemeProvider>
      <PaletteProvider>
      <div className='d-flex flex-column min-vh-100'>
        <Header />
        <ToastContainer />
        <main>
          <Container>
            <Outlet />
          </Container>
        </main>
        <Footer />
      </div>
      </PaletteProvider>
    </ThemeProvider>
  );
}